import { acceptableProjectExtensions } from '../../../config';

const getAcceptableExtensionsString = () =>
  acceptableProjectExtensions
    .map(extension => ` .${extension}`)
    .toString()
    .trim();

export default getAcceptableExtensionsString;
